import { FC } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { NotFoundPage } from '../../pages/NotFoundPage'

/**
 * Renders the matched child routes only if a `:sid` path param is present.
 * Otherwise renders NotFoundPage in place so missing-sid links show a 404
 * without changing the URL.
 */
export const RequireSid: FC = () => {
  const { sid } = useParams()
  if (!sid) {
    return <NotFoundPage />
  }
  return <Outlet />
}
